import { render, staticRenderFns } from "./player2.vue?vue&type=template&id=63989fcc"
import script from "./player2.vue?vue&type=script&lang=js"
export * from "./player2.vue?vue&type=script&lang=js"
import style0 from "./player2.vue?vue&type=style&index=0&id=63989fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports